import { doGet } from 'utils/api';
import { RELEASES } from 'utils/environment';

require('es6-promise').polyfill();

const LOAD_SIDE_PANEL_FEED_SUCCESS = 'LOAD_SIDE_PANEL_FEED_SUCCESS';
const LOAD_SIDE_PANEL_FEED_FAIL = 'LOAD_SIDE_PANEL_FEED_FAIL';

const initialState = {
  items: [],
  error: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SIDE_PANEL_FEED_SUCCESS:
      return {
        ...state,
        items: action.items,
        error: false,
      };
    case LOAD_SIDE_PANEL_FEED_FAIL:
      return {
        ...state,
        error: true,
      };
    default:
      return state;
  }
}

export function loadSidePanelFeed() {
  return dispatch => {
    return doGet(`panel_${RELEASES[0].replace('.', '_')}.txt`)
      .then(response => {
        response
          .text()
          .then(response => {
            return dispatch({
              type: LOAD_SIDE_PANEL_FEED_SUCCESS,
              items: response
                .split('\n')
                .filter(item => {
                  return item !== '';
                })
                .map(item => {
                  const itemParams = item.split('|');
                  if (itemParams[0] && itemParams[1]) {
                    return {
                      label: itemParams[0],
                      link: itemParams[1],
                    };
                  }
                  return null;
                })
                .filter(item => {
                  return item !== null;
                }),
            });
          })
          .catch(error => {
            console.log(error);
            return dispatch({
              type: LOAD_SIDE_PANEL_FEED_FAIL,
            });
          });
        return false;
      })
      .catch(error => {
        console.log(error);
        return dispatch({
          type: LOAD_SIDE_PANEL_FEED_FAIL,
        });
      });
  };
}
